import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Container,
  Divider,
  FormControl,
  FormHelperText,
  Stack,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
} from '@mui/material';
import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useDispatch, useSelector } from 'react-redux';
import {
  SendOTPByPhoneNow,
  SendOTPToChangePhoneNumber,
  VerifyOTPToChangePhoneNumber,
  VerifyToChangePhoneNumberOfCompanyOrUser,
} from '../APIs/action';
import { toast } from 'react-toastify';
import SendOtp from '../../Onboarding/Component/SendOtp';
import OTPInput from '../../Onboarding/Component/OtpInput';
import { t } from 'i18next';
import { logoutAction } from '../../Onboarding/auth/action';
import { trackUserLogout } from '../../../utils/clevertap';

const ChangePhoneNumberCard = () => {
  const naviagte = useNavigate();
  const dispatch = useDispatch();
  const { loginUser } = useSelector((state) => {
    return {
      loginUser: state.loginReducer.loginUser,
    };
  });

  const [errors, setErrors] = useState({});
  const phone_no = loginUser?.phone_no;
  const [newPhone, setNewPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [newOtp, setNewOtp] = useState('');
  const [OTPSent, setOTPSent] = useState(false);

  const handleOtpChange = (newOtp) => {
    setOtp(newOtp);
  };
  const handleNewOtpChange = (newOtp) => {
    setNewOtp(newOtp);
  };

  const handleNewOtpSend = async () => {
    if (!newPhone) return toast.error('Phone number is required');

    if (newPhone.length < 10) return toast.error('Enter a valid mobile number');

    const { error, message } = await SendOTPToChangePhoneNumber({
      phone_number: newPhone,
      edit_your_own_phone_no: true,
    });
    if (!error) {
      toast.success(
        'OTP sent successfully to new phone number and Exisiting phone number',
      );
      setOTPSent(true);
    } else {
      toast.error(message);
    }
  };
  const onLogout = async () => {
    try {
      // Track logout in CleverTap before clearing data
      await trackUserLogout();
    } catch (error) {
      // Silent fail
    }
    
    await logoutAction();
    localStorage.clear();
    dispatch({ type: 'LOGOUT' });
    naviagte('/', { replace: true });
  };

  const handleSubmit = async (e) => {
    if (!newPhone) return toast.error('Phone number is required');

    if (newPhone.length < 10) return toast.error('Enter a valid mobile number');

    if (!otp || otp.length < 4) {
      return toast.error(
        'Please enter valid OTP sent to existing phone number',
      );
    }
    if (!newOtp || newOtp.length < 4) {
      return toast.error('Please enter valid OTP sent to new phone number');
    }
    const payload = {
      otp_to_existing_phone_number: otp,
      otp_to_change_phone_number: newOtp,
      phone_number_to_change: newPhone,
    };
    const { message, error } = await VerifyOTPToChangePhoneNumber(payload);
    if (error) {
      toast.error(message);
    } else {
      toast.success(
        'Phone number change request submitted successfully, please wait for approval',
      );
    }
    setOpen(false);
    setNewPhone('');
  };
  function SimpleDialog(props) {
    const { onClose, open } = props;

    const handleClose = () => {
      onClose();
    };

    return (
      <Dialog
        onClose={handleClose}
        open={open}
      >
        <Box
          sx={{
            p: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <DialogTitle
            variant='h5'
            fontWeight={'500'}
            fontSize={'20px'}
          >
            Are you sure you want to change your Phone Number?
          </DialogTitle>

          <Stack
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              width: '100%',
              marginTop: 3,
            }}
          >
            <Button
              onClick={handleClose}
              variant='contained'
              color='error'
            >
              Cancel
            </Button>

            <Button
              onClick={handleSubmit}
              variant='contained'
            >
              Yes, Change Phone Number
            </Button>
          </Stack>
        </Box>
      </Dialog>
    );
  }
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Accordion sx={{ borderRadius: 2, mt: 5 }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{ py: 1 }}
        >
          <Typography
            fontSize={'1rem'}
            fontWeight={'bold'}
            sx={{ pl: 2 }}
          >
            Change Phone Number
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {/* <form onSubmit={handleSubmit}> */}
          <FormControl
            error={!!errors.mobile}
            fullWidth
          >
            <TextField
              margin='normal'
              required
              fullWidth
              id='phoneNumber'
              label='New Phone Number'
              name='phoneNumber'
              autoComplete='phoneNumber'
              autoFocus
              sx={{ width: '60%' }}
              value={newPhone}
              onChange={(e) => {
                if (
                  /^\d*$/.test(e.target.value) &&
                  e.target.value.length <= 10
                ) {
                  setNewPhone(e.target.value);
                }
              }}
            />
            {errors.mobile && <FormHelperText>{errors.mobile}</FormHelperText>}
          </FormControl>
          <Stack
            direction={'row'}
            spacing={4}
            alignItems={'center'}
            sx={{ mt: 2 }}
          >
            <Typography variant='subtitle2'>
              Enter OTP send to existing Phone Number
            </Typography>
            <OTPInput
              isDark={false}
              onOtpChange={handleOtpChange}
            />
          </Stack>
          <Stack
            direction={'row'}
            spacing={4}
            alignItems={'center'}
            sx={{ mt: 2 }}
          >
            <Typography variant='subtitle2'>
              Enter OTP send to new Phone Number
            </Typography>
            <OTPInput
              isDark={false}
              onOtpChange={handleNewOtpChange}
            />
            <Stack
              spacing={4}
              direction={'row-reverse'}
              alignItems={'center'}
              sx={{ mt: 2 }}
            >
              <SendOtp
                onResend={handleNewOtpSend}
                OTPSent={OTPSent}
              />
            </Stack>
          </Stack>
          <Box sx={{ mt: 2, width: '60%' }}>
            <Button
              variant='outlined'
              color='primary'
              fullWidth
              onClick={() => {
                if (!newPhone) {
                  toast.error('Phone number is required');
                  return;
                }
                if (!newOtp) {
                  toast.error('OTP is required');
                  return;
                }
                newPhone && newOtp && setOpen(true);
              }}
            >
              Change Phone Number
            </Button>
          </Box>
        </AccordionDetails>
      </Accordion>

      <SimpleDialog
        open={open}
        onClose={handleClose}
      />
    </>
  );
};

export default ChangePhoneNumberCard;
